import BaseEndpoint from "../common/BaseEndpoint";

const apiPath = '/api/v1/a/og-data';

class OpenGraphEndPoint extends BaseEndpoint {
  ogDataMainPage(data) {
    return this.client.$post(`${apiPath}/main-page`, data);
  }

  ogDataNewsList(data) {
    return this.client.$post(`${apiPath}/news-list`, data);
  }

  ogDataFaq(data) {
    return this.client.$post(`${apiPath}/faq`, data);
  }

  ogDataNews(data) {
    return this.client.$post(`${apiPath}/news`, data);
  }

  ogDataPage(data) {
    return this.client.$post(`${apiPath}/page`, data);
  }
}

export default OpenGraphEndPoint;